import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import './CustomButton.css';

const CustomButton = ({ 
  children, 
  variant = 'primary', 
  size = 'md',
  loading = false,
  disabled = false,
  fullWidth = false,
  onClick,
  type = 'button',
  className = '',
  ...props 
}) => {
  return (
    <Button
      type={type}
      className={`custom-btn custom-btn-${variant} custom-btn-${size} ${fullWidth ? 'w-100' : ''} ${className}`}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
          />
          Loading...
        </>
      ) : (
        children
      )}
    </Button>
  );
};

export default CustomButton;

